


























































import {
  computed,
  defineComponent,
  reactive,
  ref,
} from '@vue/composition-api';
import { useFormat } from '@ideavivat/vivat-2';

import drivers from '@/table/deliveryNote/drivers';
import useDriverProfile from '@/useDriverProfile';
import useAuth from '@/useAuth';

import DriverObject from '@/components/DeliveryNote/DriverObject.vue';

import getDrivers from '@/gql/driver/getDriversForSelectModal.gql';

const NOW = useFormat.date().computerShortDate();

const CommonModalWithDriverSelector = defineComponent({
  components: {
    DriverObject,
  },
  props: {
    filterDate: {},
  },
  setup(props, { emit }) {
    const { me } = useAuth();
    const { integerToArray, mapLastSevenDaysDeliveryNotes } = useDriverProfile();
    const YESTERDAY = useFormat.date(props.filterDate || null).dayjs.subtract(1, 'day').format('YYYY-MM-DD');
    const LAST7DAY = useFormat.date(props.filterDate || null).dayjs.subtract(7, 'day').format('YYYY-MM-DD');
    const modal = ref(null);
    function open() { (modal.value as any).open(); }
    function close() { (modal.value as any).close(); }

    const filterDriverDisplay = ['ลำดับการสร้าง', 'แก้ไขข้อมูลล่าสุด', 'ชื่อ'];
    const filterDriverList = ['createdAt', 'updatedAt', 'name'];
    const selectedFilterDriver = ref('createdAt');

    const search = reactive({
      driverName: '',
      driverSearchInput: '',
    });

    const driverNameSearchHandler = (searchText: string) => {
      search.driverName = searchText;
    };

    const driversVariable = computed(() => {
      const vars: {[key: string]: any} = {
        first: 6,
        searchName: undefined,
        filterFreeDate: props.filterDate ? props.filterDate : undefined,
        filterDeliveryDateBetween: {
          from: LAST7DAY,
          to: YESTERDAY,
        },
      };
      if (search.driverName) {
        vars.searchName = `%${search.driverName}%`;
      }
      return vars;
    });
    const getDriversResult = (data: any) => (data.drivers);

    function getRecentMonthCashFlow(cashFlowArr: any[]) {
      for (let i = 0; i < cashFlowArr.length; i += 1) {
        if (cashFlowArr[i].month === (new Date()).getMonth() + 1) return cashFlowArr[i].sum;
      }
      return 0;
    }

    const selectedDriver: {
      id: number;
      name: string;
      avatarUrl: string;
      employeeCode: string;
      availableVehicleType: number;
      lastSevenDay: (string | null)[];
      recentWorkDate: string;
      recentMonthCashFlow: number;
      primaryTelephone: string;
      secondaryTelephone: string;
    } = reactive({
      id: -1,
      name: '',
      avatarUrl: '',
      employeeCode: '',
      availableVehicleType: 0,
      lastSevenDay: [],
      recentWorkDate: '',
      recentMonthCashFlow: 0,
      primaryTelephone: '',
      secondaryTelephone: '',
    });
    const selectDriver = (row: any) => {
      selectedDriver.id = row.item.id;
      selectedDriver.name = row.item.name;
      selectedDriver.employeeCode = row.item.employeeCode;
      selectedDriver.avatarUrl = row.item.avatarUrl;
      selectedDriver.availableVehicleType = row.item.availableVehicleType;
      selectedDriver.lastSevenDay = mapLastSevenDaysDeliveryNotes(row.item.paginatedDeliveryNotes.data);
      selectedDriver.recentWorkDate = row.item.paginatedDeliveryNotes.data[0] ? useFormat.date(row.item.paginatedDeliveryNotes.data[0].deliveryDate).displayShortThaiDate() : '-';
      selectedDriver.recentMonthCashFlow = getRecentMonthCashFlow(row.item.cashFlowStats.months);
      selectedDriver.primaryTelephone = row.item.primaryTelephone;
      selectedDriver.secondaryTelephone = row.item.secondaryTelephone;
    };
    const clearDriver = () => {
      selectedDriver.id = -1;
      selectedDriver.name = '';
      selectedDriver.employeeCode = '';
      selectedDriver.avatarUrl = '';
      selectedDriver.availableVehicleType = 0;
      selectedDriver.lastSevenDay = [];
      selectedDriver.recentWorkDate = '';
      selectedDriver.recentMonthCashFlow = 0;
      selectedDriver.primaryTelephone = '';
      selectedDriver.secondaryTelephone = '';
    };

    function confirmDriver() {
      emit('selectDriver', { ...selectedDriver });
      close();
      clearDriver();
      selectedDriver.id = -1;
    }

    return {
      me,
      modal,
      open,
      close,

      getDrivers,
      driversVariable,
      getDriversResult,
      driversOption: drivers,

      selectedDriver,
      selectDriver,

      selectedFilterDriver,
      search,
      driverNameSearchHandler,
      drivers,

      confirmDriver,
      clearDriver,

      integerToArray,
    };
  },
});

export default CommonModalWithDriverSelector;
